import type { Container, Operation } from '@packages/core/container';

import { Ssm5Client } from '@packages/clients';

import type { Ssm5RecentConnection } from '../types';

import { toRecentConnection } from '../helpers/mappers';

/** Parameters of {@link GetLastConnection}. */
export type GetLastConnectionParams = {
    /** Aborts the lookup. */
    signal?: AbortSignal;
};

/** Look up the technician's most recent eligible SSM5 connection, reusable to reconnect its vehicle. */
export class GetLastConnection implements Operation {
    /**
     * Register this operation with the SSM5 client as its dependency.
     *
     * @param container - the container to register in
     */
    static registerInContainer(container: Container): void {
        container.register(GetLastConnection, [Ssm5Client]);
    }

    /** @param client - the SSM5 API client */
    constructor(private client: Ssm5Client) {}

    /**
     * Run the lookup.
     *
     * @param params - {@link GetLastConnectionParams}
     * @returns the last connection, or undefined when the technician has none; rejects when aborted
     */
    async exec({ signal }: GetLastConnectionParams): Promise<Ssm5RecentConnection | undefined> {
        const record = await this.client.getLastConnection(signal);

        return record && toRecentConnection(record);
    }
}
